<script lang="ts">
  import { onMount } from 'svelte'
  import { userExerciseIDStore } from '../stores/userExerciseIDStore'
  import { userExerciseDataStore } from '../stores/userExerciseDataStore'
  import { exerciseIDsStore } from '../stores/exerciseIDsStore'
  import { settingsDataStore } from '../stores/settingsStore'
  import '../exercises/exerciseImports'

  export let loaded:boolean

  onMount(() => {
    let overrideExerciseID:string|undefined = $settingsDataStore.get("exerciseID");
    if (overrideExerciseID != undefined) {
      //console.log("overrideExerciseID:" + overrideExerciseID);
      $userExerciseIDStore = overrideExerciseID;
    }

    const userExerciseID = $userExerciseIDStore
    if (userExerciseID == "") { //Default value. User has no exerciseID
      $userExerciseIDStore = $exerciseIDsStore[0] //Just choose the first exerciseID
    }
    else {
      let newExerciseIndex = $exerciseIDsStore.findIndex((testExerciseID) => testExerciseID == userExerciseID)
      if (newExerciseIndex == -1) { //Doesn't exist anymore.
        newExerciseIndex = 0; //Default to 0.
        for (let testExerciseIndex = 0; testExerciseIndex < $exerciseIDsStore.length; testExerciseIndex++) {
          const exerciseID = $exerciseIDsStore[testExerciseIndex];
          const userExerciseData = $userExerciseDataStore[exerciseID]
          if (userExerciseData && userExerciseData.completed) {
            newExerciseIndex = testExerciseIndex //The latest completed exercise is good enough.
          }
        }
        $userExerciseIDStore = $exerciseIDsStore[newExerciseIndex] //Save the value to store
      }
    }
    loaded = true
  });
</script>